import {
  ADD_FEATURE_LAYER_TO_MAP,
  REMOVE_FEATURE_LAYER_FROM_MAP,
} from '../actions/actionTypes';

const initialState = [];

const layersFeatureReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_FEATURE_LAYER_TO_MAP:
      return [...state, payload];
    case REMOVE_FEATURE_LAYER_FROM_MAP:
      return state.filter((layer) => layer.get('title') !== payload.get('title'));
    default:
      return state;
  }
};

export default layersFeatureReducer;
